import React, {Dispatch, SetStateAction, useCallback, useEffect, useRef, useState} from "react";
import {
    useAuthInfo,
} from "@propelauth/react";
import {useLocation} from "react-router-dom";
import {Button} from "../ui/button";
import {API_URL, fetchWithToken, postWithToken} from "../../api/apiBase";


export type FileUploadProps = {
    // active folder
    folder_id: string

    // callback (?) to parent component do add an uploaded file
    onAddFile: (fileView: any) => void;
};


type PathedFile = {
    file: File; // file handle
    path: string; // path - for files in folders - i know its possible to get with webkitSomething...
    // but i have not the skill or patience to figure it out.
}


type AwsPresigned = {
    fields: any;
    url: string
}

type uploadFileResponse = {
    name: string;
    formdata: AwsPresigned;
    path: string;
    file_id: string;
    folder_id: string;
    is_ok: boolean; //
}

type awsUploadData = uploadFileResponse & {
    file: File
}

function awsPostRequest(file: File, upload_data: uploadFileResponse) {
    const formData = new FormData();
    formData.append('file', file);
    for (const [key, value] of Object.entries(upload_data.formdata.fields)) {
        // @ts-ignore
        formData.append(key, value)
    }
    return formData
}


/**
 *
 * 1) client sends server http request with file size.
 * 2) server gets aws formdata, and sends to client as json (saves temp file in db)
 * 3) client sends file XHR request with file to aws
 * 4) aws sends client success or fail
 * 5) client sends server a confirmation that its all good
 * 6) server completes the save
 *
 * just to avoid server processing files ....
 *
 * ONLY TESTED FOR Single FILE - should work for multiple
 * need to do some provisioning for bigger nested uploads,
 * Retry will need to ask server for presigned url again....
 *  OR just give them longer timeouts and call it a day... 3
 *
 * */
export function DragAndDropUploadv2({folder_id, onAddFile}: FileUploadProps) {
    const {accessToken} = useAuthInfo()
    const [dragging, setDragging] = useState(false);
    const [fileQueue, setFileQueue] = useState<PathedFile[]>([]);
    const [isUploading, setIsUploading] = useState(false);

    const [uploadQueue, setUploadQueue] = useState<awsUploadData[]>([]);
    const [isProcessing, setIsProcessing] = useState(false);

    const [uploadInProgress, setUploadInProgress] = useState<number>(0)

    const [progressVal, setProgressVal] = useState<number>(0)
    const [currentFile, setCurrentFile] = useState<PathedFile | null>(null)

    const handleDragEnter = (e: React.DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setDragging(true);
    };

    const handleDragLeave = (e: React.DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setDragging(false);
    };

    const handleDragOver = (e: React.DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDrop = (e: React.DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setDragging(false);

        const items = e.dataTransfer.items;
        // Iterate through dropped items
        for (let i = 0; i < items.length; i++) {
            const item = items[i].webkitGetAsEntry();
            if (item) {
                traverseFileTree(item, "");
            }
        }
        console.log('traversed');
        setIsProcessing(true);
    };

    const traverseFileTree = (item: any, path: string = '',) => {
        if (item.isFile) {
            item.file((file: File) => {
                setFileQueue((prevQueue) => [...prevQueue, {file: file, path: path}]);
            });
        } else if (item.isDirectory) {
            // If the dropped item is a directory - traverse
            const directoryReader = item.createReader();
            directoryReader.readEntries((entries: any) => {
                entries.forEach((entry: any) => {
                    traverseFileTree(entry, path + item.name + '/',);
                });
            });
        }
    };

    useEffect(() => {
        // console.log('fq', fileQueue);
        if (fileQueue.length > 0 && isProcessing) {
            console.log('inits', fileQueue.length);
            setProgressVal(fileQueue.length);
            setUploadInProgress(fileQueue.length)
            initiate_upload(fileQueue)
        }
    }, [isProcessing, fileQueue.length])

    /**
     * STEP 1 - get signed Urls for uploads
     * we should probably do these in chucnks - or one at a time...
     * */
    const initiate_upload = (incoming: PathedFile[]) => {
        console.log('running fileq after drop', incoming.length,)
        postWithToken(
            `/files/upload_link/v2/${folder_id}`,
            JSON.stringify(incoming.map((fdata) => {
                return {name: fdata.file.name, size: fdata.file.size, path: fdata.path}
            })),
            accessToken as string)
            .then((res) => {
                console.log('result query', res)
                // now we zip the results with the file handles and upload
                const merged = []
                for (let i = 0; i < res.length; i++) {
                    const itm = {...res[i], ...incoming[i]}
                    merged.push(itm)
                }
                console.log('setting upload Queue', merged)
                // @ts-ignore
                setUploadQueue(merged)
                setIsProcessing(false)
                setFileQueue([])
            }).catch((err) => {

        })
    }

    /**
     * STEP 3 - upload to signed url
     * */
    const uploadFile2 = async (pfile: awsUploadData) => {
        // @ts-ignore
        const formData = new FormData();

        for (const [key, value] of Object.entries(pfile.formdata.fields)) {
            // @ts-ignore
            formData.append(key, value)
        }
        formData.append('file', pfile.file);
        try {
            const response = await fetch(pfile.formdata.url, {
                method: 'POST',
                body: formData,
            });
            if (response.ok) {
                console.log('File uploaded successfully');
                sendConfirmation(pfile, 'success');
            } else {
                console.error('Failed to upload the file', response.statusText);
                sendConfirmation(pfile, 'fail');
            }
        } catch (error) {
            console.error('Error uploading the file', error);
            sendConfirmation(pfile, 'error')
        }
    }

    /**
     * STEP 5
     * */
    const sendConfirmation = (pfile: awsUploadData, result: string) => {
        // @ts-ignore
        delete pfile['file'];
        console.log('sending upload confirmation', pfile, result)
        postWithToken(
            `/files/upload_confirmation/v2/${result}`,
            JSON.stringify(pfile), accessToken as string)
            .then(result => {
                console.log('confirmation complete :', result)
                // todo
                if (onAddFile && pfile.path === "") {
                    onAddFile(pfile)
                }
                setProgressVal((p) => p - 1)
            })
            .catch(err => {
                console.log('confirmation errir', err)
                setProgressVal((p) => p - 1)
        })
    }

    useEffect(() => {
        const processQueue = async () => {
            // just gonna do a queue for now ... and hopefully not screw it up.
            if (uploadQueue.length > 0 && !isUploading) {

                setIsUploading(true);
                const fileToUpload = uploadQueue[0];
                setCurrentFile(fileToUpload)

                console.log('procesing file:', fileToUpload)
                await uploadFile2(fileToUpload);
                // Send the server
                // deque
                setUploadQueue((prevQueue) => prevQueue.slice(1));
                console.log('file processed:', fileToUpload)
                setIsUploading(false);
            }
        };
        processQueue();
    }, [uploadQueue, isUploading,]);

    return (
        <div className="max-w-lg mx-auto">
            <div
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
                // andri's styles
                className="inline-block text-gray-600 mb-4 flex-grow flex flex-col border-2
                     items-center justify-center p-4 transition duration-300 ease-in-out hover:shadow-lg"
                style={{cursor: "pointer"}}
            >
                {dragging ? <p>Drop here...</p> : <p>Drag and drop files or folders here</p>}
            </div>
            {(progressVal > 0) &&
                <>
                    {/*<div>{currentFile.path + currentFile.file.name}</div>*/}
                    <progress value={1 - progressVal / uploadInProgress}/>
                </>
            }
        </div>
    );
}

